import { render, staticRenderFns } from "./NewExaminer.vue?vue&type=template&id=d28a5bee&scoped=true&"
import script from "./NewExaminer.vue?vue&type=script&lang=js&"
export * from "./NewExaminer.vue?vue&type=script&lang=js&"
import style0 from "./NewExaminer.vue?vue&type=style&index=0&id=d28a5bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28a5bee",
  null
  
)

export default component.exports